module.exports = (i, ...r) => globalThis.fetch(i, ...r)
